import { atom, useAtom } from "jotai";

const sidebar = atom<{ open: false } | { open: true; relativeRedirectUrl?: string; type: "signup" | "login" }>({
    open: false,
});

export function useSidebar() {
    return useAtom(sidebar);
}
